// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import UserEditScreen from "../../src/screens/users/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} UserNewRouteProps */

/** @typedef {Record<string, never>} UserNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<UserNewRouteProps, UserNewRouteState>}
 */
class UserNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New user")}</ScreenTitle>
        <UserEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<UserNewRouteProps>} */
const UserNewRouteComponent = memo(shapeComponent(UserNewRoute))

export default UserNewRouteComponent
